import { Model, type ModelProps } from '@/infra/model'
import { computed, observable } from 'mobx'
import type { SupportingItemInputBase } from '../supporting-item-input'
import { toStream } from '@/utils/mobx-util'

/**
 * Props for {@link BusinessTaxRefundMethodSupportingItemInput}.
 */
export type BusinessTaxRefundMethodSupportingItemInputProps =
  ModelProps<BusinessTaxRefundMethodSupportingItemInput> & {
    type: 'BusinessTaxRefundMethod'
  }

/**
 * Supporting item input for a business tax refund method.
 */
export class BusinessTaxRefundMethodSupportingItemInput
  extends Model<BusinessTaxRefundMethodSupportingItemInput>
  implements SupportingItemInputBase
{
  /**
   * The provided business tax refund method, if any.
   */
  @observable.struct accessor provided: ProvidedBusinessTaxRefundMethod | null =
    null

  /**
   * Stream of changes to the provided business tax refund method.
   */
  readonly providedChanges$ = toStream(() => this.provided)

  /** @inheritDoc */
  @computed get isCompleted() {
    return !!this.provided
  }
}

/**
 * A provided business tax refund method.
 */
export interface ProvidedBusinessTaxRefundMethod {
  readonly refundMethodId: string
  readonly refundMethodVersion: number
}
